import { createAction } from "typesafe-actions";
export var display = createAction("feedbackDisplayed/DISPLAY");
export var hide = createAction("feedbackDisplayed/HIDE");